/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-21T19:19:46-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-11T11:01:00-07:00
*/



import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { type, color, textColor } from '../../style';

const style = StyleSheet.create({
  title: {
    fontWeight: '700',
    ...type.LG,
    // ...spacing.MARGIN_BOTTOM_SM
  },

  centered: {
    textAlign: 'center'
  },

  // Sizes [1-3] corrsponds to heading sizes in HTML

  level_1: {
    ...type.title.LG
  },

  level_2: {
    ...type.title.MD
  },

  level_3: {
    ...type.title.SM
  }

});



const Title = (props) => {
  const {
    children,
    size,
    center,
    extraStyles,
    extraClasses,
    ...rest
  } = props;




  return (
    <span
      style={{...extraStyles}}
      className={ css(style.title, style[`level_${size}`], center && style.centered, ...extraClasses)}>
      {children}
    </span>
  )
}

Title.defaultProps = {
  size: 'level_2',
  center: 'false',
  extraClasses: {},
  extraStyles: {}
}


export default Title;



// WEBPACK FOOTER //
// ./src/components/common/Title.jsx